import styled from '@emotion/styled';
import { Checkbox } from '@kc-console/common-ui';

const DataTableCheckbox = styled(Checkbox)``;

export default DataTableCheckbox;
